export enum EDriverStatus {
  Active = 'active',
  Inactive = 'inactive'
}
export enum EDriverAssignedStatus {
  Assigned = 'assigned',
  Unassigned = 'unassigned'
}
export interface IDriversFiltersForm {
  driver: {
    id: string
    name: string
  }
  email: string
  phoneNumber: string
  partner: {
    id: string
    name: string
  }
  status: EDriverStatus | ''
  assigned: EDriverAssignedStatus | ''
}

export interface IDriverPersonalInformationFormValues {
  firstName: string
  lastName: string
  partner: {
    id: string
    name: string
  }
  phone?: string
  email?: string
  state?: string
  gender?: string
}

export interface IDriverLicenseFormValues {
  type?: string
}

export interface INewDriverStep1 extends IDriverPersonalInformationFormValues, IDriverLicenseFormValues {}

export interface IDriverDocumentsValues {
  category: string
  file: File | string
  filename?: string
}

export interface INewDriverStep2 {
  documents: IDriverDocumentsValues[]
}
